<script lang="ts" setup>
import { LabelComponent } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import type { LabelProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { useFormField } from './useFormField';

const props = defineProps<LabelProps & { class?: HTMLAttributes['class'] }>();

const { error, formItemId } = useFormField();
</script>

<template>
  <LabelComponent :class="cn(error && 'text-destructive', props.class)" :for="formItemId">
    <slot />
  </LabelComponent>
</template>
